import { Box, CircularProgress, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CourseCard from "../../CourseCard/CourseCard";
import { fetchEnrolledCourses } from "./../../../redux/Actions/enrolledStudentCoursesActions";
import { fetchPlacementTestStatus } from "./../../../redux/Actions/studentPlacementActions";
import PaymentHistory from "./PaymentHistory";
import PlacementTestStatus from "./PlacementTestStatus";

const CoursesGrid = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const { enrolledCourses, loading: enrolledCoursesLoading } = useSelector(
    (state) => state.enrolledStudentCourses || {}
  );
  const { status } = useSelector((s) => s.studentPlacement);

  useEffect(() => {
    dispatch(fetchEnrolledCourses());
    dispatch(fetchPlacementTestStatus());
  }, [dispatch]);

  const initialTab = new URLSearchParams(location.search).get("tab");
  const [selectedTab, setSelectedTab] = useState(
    initialTab === "placementTestResult" || initialTab === "paymentHistory"
      ? initialTab
      : "enrolled"
  );

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    setSelectedTab(
      tab === "placementTestResult" || tab === "paymentHistory" ? tab : "enrolled"
    );
  }, [location.search]);

  const enrolledCourseList = Array.isArray(enrolledCourses)
    ? enrolledCourses.flatMap((group) =>
        Array.isArray(group?.courses) ? group.courses : []
      )
    : [];

  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
  };
  return (
    <Box sx={{ py: "32px", my: "64px", px: { xs: 2, sm: 4 } }}>
      {/* Student course and account tabs */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="standard"
        sx={{
          fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
          mb: 4,
          color: "#000",
          display: "flex",
          minHeight: { xs: 32, sm: 48 },
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: "#000",
            height: 2,
          },
        }}
      >
        <Tab
          value="enrolled"
          label={t("studentDashboard.tabs.enrolled")}
          sx={{
            textTransform: "none",
            fontWeight: "normal",
            minWidth: { xs: 60, sm: 100 },
            fontSize: { xs: "0.85rem", sm: "1rem" },
            color: "#888",
            "&.Mui-selected": {
              color: "#000",
              fontWeight: "bold",
            },
            py: { xs: 0.5, sm: 1 },
          }}
        />
        {(status?.hasSession || selectedTab === "placementTestResult") && (
          <Tab
            value="placementTestResult"
            label={t("studentDashboard.tabs.placementTestResult")}
            sx={{
              textTransform: "none",
              fontWeight: "normal",
              minWidth: { xs: 60, sm: 100 },
              fontSize: { xs: "0.85rem", sm: "1rem" },
              color: "#888",
              "&.Mui-selected": {
                color: "#000",
                fontWeight: "bold",
              },
              py: { xs: 0.5, sm: 1 },
            }}
          />
        )}
        <Tab
          value="paymentHistory"
          label={t("studentDashboard.tabs.paymentHistory")}
          sx={{
            textTransform: "none",
            fontWeight: "normal",
            minWidth: { xs: 60, sm: 100 },
            fontSize: { xs: "0.85rem", sm: "1rem" },
            color: "#888",
            "&.Mui-selected": {
              color: "#000",
              fontWeight: "bold",
            },
            py: { xs: 0.5, sm: 1 },
          }}
        />
      </Tabs>
      {/* Grid layout */}
      {selectedTab === "paymentHistory" ? (
        <PaymentHistory />
      ) : selectedTab !== "placementTestResult" ? (
        enrolledCoursesLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress />
          </Box>
        ) : enrolledCourseList.length === 0 ? (
          <Typography color="text.secondary" mt={3}>
            {t("noEnrolledCourses")}
          </Typography>
        ) : (
          <Grid container spacing={4}>
            {enrolledCourseList.map((course) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                key={course.teacherCourseId || course.id || course.title}
              >
                <Box sx={{ width: "100%" }}>
                  <CourseCard {...course} enrolledView />
                </Box>
              </Grid>
            ))}
          </Grid>
        )
      ) : (
        <Box sx={{ mt: 2 }}>
          <PlacementTestStatus />
        </Box>
      )}
    </Box>
  );
};

export default CoursesGrid;
